export default __webpack_public_path__ + "static/media/Youth_Illustrations-BC.7bd6e892.png";